'use client';
import { useEffect, useState } from 'react';

import { Duration, intervalToDuration, isPast } from 'date-fns';

const toFormat = (duration: Duration) => {
  let formattedTime = '';
  let shouldDisplayUnits = false;

  if (duration.days) {
    shouldDisplayUnits = true;
    formattedTime += `${duration.days}D:`;
  }

  if (duration.hours || shouldDisplayUnits) {
    shouldDisplayUnits = true;
    formattedTime += `${duration.hours ?? 0}H:`;
  }

  if (duration.minutes || shouldDisplayUnits) {
    shouldDisplayUnits = true;
    formattedTime += `${duration.minutes ?? 0}M`;
  }

  return formattedTime;
};

const computeValue = (endDate: Date): Duration =>
  intervalToDuration({
    start: Date.now(),
    end: endDate,
  });

export function useCountdown(endDate: Date, updateInterval = 60000): Duration {
  const [value, setValue] = useState(computeValue(endDate));

  useEffect(() => {
    const timer = setInterval(() => {
      setValue(computeValue(endDate));
      if (isPast(new Date(endDate))) {
        clearInterval(timer);
      }
    }, updateInterval);

    return () => {
      clearInterval(timer);
    };
  }, [endDate, updateInterval]);

  return value;
}

interface ICountdownProps {
  endDate: Date;
}

export const Countdown = ({ endDate }: ICountdownProps) => {
  const countdown = useCountdown(endDate);
  const finished = isPast(new Date(endDate));

  const formattedTime = countdown && !finished ? toFormat(countdown) : '';

  return <>{formattedTime}</>;
};
